

























import SharedContentMixin from "@/components/partner/SharedContentMixin.vue";
import SharedContentTable from "@/components/partner/SharedContentTable.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { $t } from "@/lib/utility/t";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { SharedContentModule } from "@/store/modules/shared-content.store";
import { mixins } from "vue-class-component";
import { Component, Ref } from "vue-property-decorator";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import AttachmentRequestTable from "@/components/partner/AttachmentRequestTable.vue";

export type Tabs = BackendResourceEnum.SHARED_CONTENT | BackendResourceEnum.ATTACHMENT_REQUEST;

@Component({
  components: {
    TheLayoutPortal,
    SharedContentTable,
    AttachmentRequestTable,
    MHeader
  }
})
export default class SharedContentView extends mixins(PartnerFallbackMixin, SharedContentMixin) {
  loading = false;
  tab = 0;

  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  @Ref("sharedContentTable")
  sharedContentTable!: SharedContentTable;

  readonly AMOUNT_COST = "amountSharedContent";

  get partnerId(): string {
    return this.$route.params.partnerId;
  }

  get breadCrumbList(): IBreadcrumb[] {
    const crumbs: IBreadcrumb[] = [];

    crumbs.push({
      text: $t("sharedContent.sharedContents").toString(),
      exact: true,
      to: { name: this.$route.name as string, params: this.$route.params }
    });

    return crumbs;
  }

  get chips(): IAction[] {
    const chips: IAction[] = [];

    chips.push({
      text: `${SharedContentModule.totalItems} ${this.$t("sharedContent.sharedContents")}`,
      key: this.AMOUNT_COST,
      disabled: true
    });

    return chips;
  }

  get items() {
    const items = [];

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SHARED_CONTENT, PartnerModule.partner.id))
      items.push("sharedContent.sharedContentTable");

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.ATTACHMENT_REQUEST, PartnerModule.partner.id))
      items.push("objects.attachmentRequest.title");

    return items;
  }

  get tabs() {
    const tabOptions: string[] = [];
    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SHARED_CONTENT, PartnerModule.partner.id)) {
      tabOptions.push(ResourceEnum.SHARED_CONTENT);
    }
    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.ATTACHMENT_REQUEST, PartnerModule.partner.id)) {
      tabOptions.push(ResourceEnum.ATTACHMENT_REQUEST);
    }

    return tabOptions;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  beforeMount() {
    SharedContentModule.setFilters([]);
  }

  async mounted() {
    const tab = this.$route.params.tab;
    this.setTab(tab as Tabs);

    await this.trySetByRouteOrDefault();

    const sharedContentId = this.$route.query.sharedContentId as string;
    if (sharedContentId) {
      const sharedContent = new SharedContent({ partnerId: this.partnerId, id: sharedContentId });
      this.sharedContentTable?.openDetail(sharedContent);
    }
  }

  openSideCard(sharedContent: ISharedContent) {
    new GoToHelper(this.$router).setUrl({
      name: this.$route.name as string,
      params: this.$route.params,
      query: { sharedContentId: sharedContent.id }
    });
  }

  setTab(tab: Tabs) {
    this.tab = 0;
    if (tab) {
      const index = this.tabs.indexOf(tab);

      if (index > -1) {
        this.tab = index;
      }
    }
  }
}
